import { OPERATION } from './handlers'
import { drawInteraction, enableEditButtons } from './map/drawing'
import { getLayerById } from './map/tools'
import { cursorType, guiConfiguration, i18n, locallyAr5 } from './storage'
import { redStyle } from './styles'

export const simpleToast = (message, level) => {
  const c = guiConfiguration.toolbar ? 'toast-with-toolbar' : '';
  const severity = level ? (c ? ' ' : '') + level : '';
  // console.log(c + severity);
  Materialize.toast(
    message,
    6000,
    c + severity // assign a class
  );
};
export const materializeToast = (message, severity) => {
  let level = 'info';
  if (['error', 'warning'].indexOf(severity) > -1) level = severity;
  simpleToast('<h5>' + message + '</h5>', level);
};

export function makeMessagebox() {
  if (!locallyAr5) return;
  const mbd = document.createElement('div');
  mbd.id = 'greenMessageBox';

  const table = document.createElement('table');
  const tr = document.createElement('tr');
  const td1 = document.createElement('td');

  const mbi = document.createElement('i');
  mbi.className = 'material-icons';
  mbi.innerHTML = 'check_circle';
  td1.appendChild(mbi);
  tr.appendChild(td1);

  const td2 = document.createElement('td');
  const mbt = document.createElement('div');
  mbt.id = 'messageBoxText';
  // mbt.innerHTML = i18n['greenMessages']['startupMessage'];
  td2.appendChild(mbt);
  tr.appendChild(td2);

  const td3 = document.createElement('td');
  const a = document.createElement('a');
  const linkText = document.createTextNode('Lukk');
  a.appendChild(linkText);
  a.title = 'Lukk denne';
  a.id = 'closeMessageBox'
  a.onclick = closeMessageBox;
  td3.appendChild(a);
  tr.appendChild(td3);

  table.appendChild(tr);
  mbd.appendChild(table);
  document.body.appendChild(mbd);
}

export function closeMessageBox(){
  if (!locallyAr5) return;
  document.getElementById('greenMessageBox').style.display = 'none';
}

export function showMessageBox(input_text, color = '#009A3E') {
  // NIBIO yellow = FFD500 Red = E94E0F
  if (!locallyAr5) return;
  const icon = document.querySelector("#greenMessageBox .material-icons");
  icon.innerText = ((color !== '#009A3E') ? 'warning' : 'check_circle');

  document.getElementById('greenMessageBox').style.backgroundColor = color;
  document.getElementById('greenMessageBox').style.display = 'block';
  document.getElementById('messageBoxText').innerHTML = i18n['greenMessages'][input_text];
}

const furtherInfo = (msg, info) => {
  if (!info) return msg;
  let translated;
  const too = {
    many: 'Surface split count exceeded limit of 1',
    manyAgain: 'is bigger than maxNewSurfacesOrChangedAreaSurfaces',
    short: 'Non closed linestring does not intersect at least twice',
    shortAgain: 'no face was split by border detail',
    small: 'No usable input lines found with minimum tolerated face area',
    last: ''
  };
  if ((info.indexOf(too.many) > -1) || (info.indexOf(too.manyAgain) > -1))
    translated = 'grense som gir for mange flater';
  else if ((info.indexOf(too.short) > -1) || (info.indexOf(too.shortAgain) > -1))
    translated = 'grense som ikke gir en flate';
  else if (info.indexOf(too.small) > -1) {
    const min = (info.indexOf('isClosed = t') > -1) ? '0,2' : '0,01';
    translated = `grense som gir for liten flate (< ${min} dekar)`;
  } else console.log(`You should translate it and add it as a case: "${info}"`);
  const morePrecise = msg.replace('ulovlig grense', translated);
  return translated ? morePrecise : msg;
};

export const notifyStatusCode = (action, code, errorInfo) => {
  // console.log('Notify', action, code);
  let msg = 'Det ble feil. Prøv på nytt og/eller sjekk om du har rettighet her!';
  if (locallyAr5) switch (action) {
    case 'add':
      // console.log('A new line has been drawn');
      switch (code) {
        case 3: // INPUT_LINE_NOT_USED
          // console.log('Invalid input line.');
          msg = 'Endring er ikke blitt lagret. Du har tegnet en ulovlig grense';
          break;
        case 2: // NOT_EDITABLE
          // console.log('User has no right to draw here.');
          msg = 'Endring er ikke blitt lagret. Du mangler rettigheter til å oppdatere i dette området';
          break;
        case 1: // OK
          showMessageBox('saveMessage');
          break;
        default: // (0) FAILED
          if (!locallyAr5) console.log('Generic error, it should not happen.');
          msg = 'Endring er ikke blitt lagret. Du har tegnet en ulovlig grense';
      }
      break;
    case 'edit_new':
      console.log('A new (empty properties) geometry has been modified');
      break;
    case 'edit':
      console.log('An existing geometry has been modified');
      break;
    default:
      console.log('Something unhandled');
  }
  if (code !== 1) materializeToast(furtherInfo(msg, errorInfo), 'error');
};

export const loadingGeometry = (loading) => {
  if (loading) {
    $('.progress').show();
    // map.getTargetElement().style.cursor = 'wait';
    map.style.cursor = 'wait';
  } else {
    $('.progress').css('display', 'none');
    // map.getTargetElement().style.cursor = cursorType;
    map.style.cursor = cursorType;
  }
  enableEditButtons(); // or disable.
};

export const notifyDrawingOutside = (pixel) => {
  if (OPERATION === 'add') {
    const u = getLayerById('utenforWMS');
    if (u && u.getVisible()) {
      const rgba = u.getData(pixel);
      if (rgba && rgba.length > 3) {
        const hit = (rgba[3] !== 0);
        // map.getTargetElement().style.cursor = hit ? 'no-drop' : 'pointer';
        //map.getTargetElement().style.cursor = hit ? 'not-allowed' : 'pointer';
        map.style.cursor = hit ? 'not-allowed' : 'pointer';
        const ff = drawInteraction.getOverlay().getSource().getFeatures();
        const drawingStyle = hit ? redStyle : null;
        // drawnVectorLayer.setStyle(drawingStyle);
        // drawInteraction.getOverlay().setStyle(drawingStyle); // miss default
        ff[0]?.setStyle(drawingStyle); // point
        ff[1]?.setStyle(drawingStyle); // curve
      }
    }
    // map.forEachLayerAtPixel(pixel, l => { // deprecated
    //   console.log(l.get('id'));
    // }, { layerFilter: g => g.get('id') === 'utenforWMS' });
  }
};

